import axios from 'axios';
import auth from './auth';

// Create axios instance with default configuration
// Timeout 60s to allow for cold starts (e.g. Render free tier waking up)
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://fabritech-training-center.onrender.com/api',
  timeout: 60000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - include the saved auth token when present
api.interceptors.request.use(
  (config) => {
    const token = auth.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized
    if (error.response && error.response.status === 401) {
      auth.clearAuth();
    }

    // Handle network errors (timeout, no connection, etc.)
    if (!error.response) {
      console.error('Network error:', error.message);
      const isTimeout = error.code === 'ECONNABORTED' || error.message?.includes('timeout');
      const message = isTimeout
        ? 'The request took too long. The server may be starting up—please try again in a moment.'
        : 'Network error. Please check your connection.';
      return Promise.reject({ message });
    }

    // Return error response for specific handling
    return Promise.reject(error.response.data);
  }
);

export default api;
